import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
import { Message } from "element-ui";
const speakers = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 1000,
      total: 0,
      page: 1
    },
    liveStreamFilter: {
      searchTerm: null,
      skip: 0,
      take: 1000,
      total: 0,
      page: 1,
      ids: []
    },
    selectedItems: [],
    loading: true
  }),
  mutations: {
    setSpeakers(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
    },
    setSelectedSpeakers(state, payload) {
      state.selectedItems = payload;
    },
    setSpeakerPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getSpeakers");
    },
    setSpeakerTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getSpeakers");
    }
  },
  actions: {
    async saveSpeakerSort(context, payload) {
      var res = await axios.post("/speaker/UpdateOrderNos", { ids: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
    },
    async getSpeakers(store) {
      store.state.loading = true;
      var res = await axios.post("speaker/list", {
        ...store.state.filter,
        skip: 0,
        take: 9999
      });

      store.state.loading = false;
      return store.commit("setSpeakers", res.data.data);
    },
    async toggleSpeakerNew(store, payload) {
      var res = await axios.post("speaker/toggleisactive", {
        id: payload
      });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res.data;
    },
    async toggleActiveSpeaker(store, payload) {
      var res = await axios.post("speaker/toggleisactive", {
        id: payload
      });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }

      return res;
    },
    async getSpeaker(store, payload) {
      var res = await axios.post("speaker/get", { id: payload });
      return res;
    },
    async speakerAddOrUpdate(store, payload) {
      var res = await axios.post("speaker/addorupdate", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async deleteSpeakerPage(store, payload) {
      var res = await axios.post("speaker/delete", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    }
  },
  getters: {}
};
export default speakers;



// WEBPACK FOOTER //
// ./src/store/speakers.js